import React from "react";

const FirstMsg = () => {
  return (
    <div>
      <p>
        {" "}
        {">"} $suman-portfolio <span>npm</span> start <br /> {">"}{" "}
        reactweb@0.1.0 start <br /> {">"} react-scripts start <br />
      </p>
    </div>
  );
};

export default FirstMsg;
